import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import PlatformsPage from "@/components/screens/Platforms";
import { PLATFORMS_MESSAGES, PlatformsMessages } from "@/messages/platforms/platforms.messages";
import translationService from "@/services/translation.service";
import { Language } from "@/types/language.types";

const PlatformsMainPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams<{ lang?: string }>();
  const [messages, setMessages] = useState<PlatformsMessages | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<PlatformsMessages>(
          PLATFORMS_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return <PlatformsPage messages={messages} />;
};

export default PlatformsMainPage;
